import { createReducer } from 'utils/reduxCreators';
import { fetchGuarantorDetails } from 'services/accountDetails';

const initialState = {
  entities: {},
  currentAccountAdfitNo: '',
};

export const UPDATE_GUARANTOR_DETAILS = 'guarantor/UPDATE_GUARANTOR_DETAILS';
export const UPDATE_CURRENT_ACCOUNT_ADFIT_NO =
  'guarantor/UPDATE_CURRENT_ACCOUNT_ADFIT_NO';

export default createReducer(initialState, {
  [UPDATE_GUARANTOR_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      entities: payload,
    };
  },
  [UPDATE_CURRENT_ACCOUNT_ADFIT_NO]: (state, { payload }) => {
    return {
      ...state,
      currentAccountAdfitNo: payload,
    };
  },
});

export const getGuarantorDetailsByAdfitNo = (adfitNo) => async (dispatch) => {
  const result = await fetchGuarantorDetails(adfitNo);
  dispatch({
    type: UPDATE_GUARANTOR_DETAILS,
    payload: result,
  });
  dispatch({
    type: UPDATE_CURRENT_ACCOUNT_ADFIT_NO,
    payload: adfitNo,
  });
};
